import { useTheme } from "@emotion/react";
import { BarTimeChart } from "./bar_time_chart";
import { getBarTimeChartOptions } from "./chart_options";

export function ImbalancePriceEpexChart({ prices, multiDay = false }) {
  const theme = useTheme();

  if (!prices) return;
  const utctime = prices.map((el) => new Date(1000 * el.utctime));
  const epex = prices.map((el) => el.epex);
  const imbalanceprice = prices.map((el) => el.imbalanceprice);

  const data = {
    labels: utctime,
    datasets: [
      {
        fill: true,
        label: "Imbalance Price",
        data: imbalanceprice,
        borderWidth: 0,
        borderColor: theme.palette.imbPrice.main,
        backgroundColor: theme.palette.imbPrice.main,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        order: 2,
      },
      {
        fill: false,
        label: "Epex",
        data: epex,
        borderWidth: 3,
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        type: "line",
        order: 1,
        spanGaps: true,
      },
    ],
  };

  const options = getBarTimeChartOptions(multiDay);
  options.scales.y.title = { ...options.scales.y.title, display: true, text: "€/MWh" };

  return <BarTimeChart data={data} options={options} />;
}
